import { render, staticRenderFns } from "./Street-lover.vue?vue&type=template&id=58bb9f06&scoped=true&"
import script from "./Street-lover.vue?vue&type=script&lang=js&"
export * from "./Street-lover.vue?vue&type=script&lang=js&"
import style0 from "./Street-lover.vue?vue&type=style&index=0&id=58bb9f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb9f06",
  null
  
)

export default component.exports